import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import { useDigitalShelfEvolutionData } from "./@hooks"
import DigitalShelfEvolutionChartToolbar from "./Toolbar"


export default function DigitalShelfEvolutionChart() {

    const {
        isLoadingDataEvolution, dataEvolution, dataEvolutionKeys,
        country, retailer, brand,
        kpiKey, dateRange, onChange, resetEvolutionData
    } = useDigitalShelfEvolutionData()

    if (!dataEvolution?.length || isLoadingDataEvolution) return <></>
    
    const countryInTitle = country ? ` - ${country}` : '';
    const retailerInTitle = retailer ? ` - ${retailer}` : '';
    const brandInTitle = brand ? ` - ${brand}` : '';

    return <ModalSeeker
        hideActions 
        isOpen={!!dataEvolution?.length} 
        title={`Evolution by ${dataEvolutionKeys[0]}${countryInTitle}${retailerInTitle}${brandInTitle}`}
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
        data={dataEvolution}
        title={<Box id="evolution-chart"></Box>}
        pdfProps={{
            titlePDF:`Evolution by ${dataEvolutionKeys[0]}${countryInTitle}${retailerInTitle}${brandInTitle}`
        }}
                series={dataEvolutionKeys.map(key => ({
                    name: key, yField: key,
                    xField: "date",
                    connect: true,
                }))}
                chartProps={{
                    numberFormat: `#,###'%'`,
                    dateFormatReceived: 'yyyyMMdd',
                    xAxis: {
                        categoryField: 'date',
                        isDateAxis: true,
                        dateFormat: 'dd MMM yyyy',
                        baseInterval: {
                            timeUnit: 'day',
                            count: 1
                        }
                    },
                    yAxis: {
                        numberFormat: "#'%'"
                    }
                }}
                cardProps={{ actions: <DigitalShelfEvolutionChartToolbar kpi={kpiKey} dateRange={dateRange} onChange={onChange} /> }}
                sx={{ height: 500 }}
            />
    </ModalSeeker>
}